import { isKeyCode } from './key-composition.js';
var handlers = [];
var escDown = false;
export default {
  __install: function __install() {
    this.__installed = true;
    window.addEventListener('keydown', function (evt) {
      escDown = evt.keyCode === 27;
    });
    window.addEventListener('blur', function () {
      escDown === true && (escDown = false);
    });
    window.addEventListener('keyup', function (evt) {
      if (escDown === true) {
        escDown = false;

        if (handlers.length !== 0 && isKeyCode(evt, 27) === true) {
          handlers[handlers.length - 1].fn(evt);
        }
      }
    });
  },
  register: function register(comp, fn) {
    if (comp.$q.platform.is.desktop === true) {
      this.__installed !== true && this.__install();
      handlers.push({
        comp: comp,
        fn: fn
      });
    }
  },
  pop: function pop(comp) {
    if (comp.$q.platform.is.desktop === true) {
      var index = handlers.findIndex(function (h) {
        return h.comp === comp;
      });

      if (index > -1) {
        handlers.splice(index, 1);
      }
    }
  }
};